import { IconDigitalBooks } from "@studyplus/boron-ui";
import ContentBox from "../../components/atoms/ContentBox";
import { MultiSectionBatchesDescription } from "../../components/features/MultiSectionBatches/MultiSectionBatchesDescription";
import { BreadcrumbsView } from "../../components/general/BreadcrumbsView";
import TabsNavi from "../../components/molecules/TabsNavi";

const HELP_URL =
  "https://fs-help.studyplus.co.jp/ja/articles/14648515-%E3%83%87%E3%82%B8%E3%82%BF%E3%83%AB%E6%95%99%E6%9D%90-%E3%83%89%E3%83%AA%E3%83%AB-%E9%80%B2%E5%BA%A6%E8%A1%A8-%E3%81%AE%E5%85%A5%E7%A8%BF%E6%96%B9%E6%B3%95";

type ActiveTab = "new" | "list" | "history";

const getTabs = (activeTab: ActiveTab) => [
  {
    label: "新規登録",
    link: "/multi_section_batches/upload_drill",
    active: activeTab === "new",
  },
  {
    label: "登録一覧",
    link: "/multi_section_batches/upload_drill/list",
    active: activeTab === "list",
  },
  {
    label: "操作履歴",
    link: "/multi_section_batches/upload_drill/history",
    active: activeTab === "history",
  },
];

const breadcrumbItems = [
  { label: "校舎横断操作", url: "/multi_section_batches" },
  { label: "デジタル教材の登録" },
];

type LayoutProps = {
  activeTab: ActiveTab;
  children?: React.ReactNode;
};

export const Layout = ({ activeTab, children }: LayoutProps) => {
  return (
    <div className="flex flex-col md:w-[90%]">
      <div className="py-5">
        <BreadcrumbsView items={breadcrumbItems} />
      </div>
      <ContentBox className="md:w-[80%] md:p-10">
        <div className="flex items-center gap-6">
          <IconDigitalBooks className="text-gray-600" />
          <h2 className="text-xl">デジタル教材の登録</h2>
        </div>
        <MultiSectionBatchesDescription
          helpUrl={HELP_URL}
          isOnlyLearningManagementStudent={false}
          noteText=""
          className="!mt-[16px] !mb-[16px]"
        />
        <TabsNavi tabs={getTabs(activeTab)} />
        {children}
      </ContentBox>
    </div>
  );
};
